import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "components/Page";
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Select } from "react-inputs-validation";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Alert, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  FetchDescargarCotizacion,
  FetchEnviaCotizacionAccP,
  fetchObtenerPlanes,
  fetchProcesoCarritoAccP,
  fetchRecuperarCarritoAccP,
  fetchUpdateProcesoCarritoAccP
} from "../../redux/actions/aRamoAccidentesPersonales";
/*ES */
import ValoresCotizacionAccPersonal from "./ValoresCotizacionAccPersonal";
import AgregarPersonas from "./AgregarPersonas/AgregarPersonas.js";

class ListadoProductoAPersonal extends React.Component {
  constructor(props) {
    super(props);

    //  const dir = this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion.direccion
    //  const ciu =  this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion.ciudad
    //  const prov= this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion.provincia

    this.state = {
      validate: false,
      hasNumDiasError: "",
      formEditado: false,
      idCarrito: this.props.datosCarritoAccP.productoAccP.idCarrito,
      idPlan: this.props.datosProductoCarritoAPTravelGroup
        .productoAPTravelGroup["codProd"],
      okDescarga: false,
      linkDescarga: "",
      okEnvio: false,
      idEmpresa: "",
      idPersona: "",
      nomEmpresa: "",
      nomPersona: "",
      provincia: "",
      ciudad: "",
      direccion: "",
      PrimaNeta: "",
      impuestosTotales: "",
      primaTotal: "",
      impuestosDetalle: [],
      periodoSeleccionado: "0",
      urlPdf: "",
      msgFactuacion: "La periodicidad de facturación es Anual",
      actividadEmpresa: "",

      /*ES */
      rendervista: "resumen", //Render Vista del Resumen o de Agregar Personas
      datosPlan: {}, //Plan Actual,
      datosResumen: [],
      dataPersonalPlan: [],
      dataPersonalAdm: [],
      datosPlanPrincipal: {},
      datosPlanSecundario: {},
    };

    this.onClickRegresar = this.onClickRegresar.bind(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.periodoSeleccionado !== this.state.periodoSeleccionado) {
      this.cargarPeriodicidadFacturacion();
    }
  }
  recuperarCarrito=async ()=>{
      this.componentDidMount();
  }
   async cargarPeriodicidadFacturacion() {
    const dataPlan = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
      .carProductos[0];

    await this.props.procesoCarrito({
      empresa: "AIGMETROPOLITANA",
      pasoCarrito: "resumen",
      periocidad: this.state.periodoSeleccionado,
      idCarrito: this.state.idCarrito,
      codigoProductoActual: dataPlan.codigo,
    });

    if (!this.props.datosProcesoCarritoAccP.procesoCarritoAccPhasError) {
      const {
        PrimaNeta,
        impuestosTotales,
        primaTotal,
        impuestosDetalle,
      } = this.props.datosProcesoCarritoAccP.procesoCarritoAccP.datosCalculados;

      this.setState({
        PrimaNeta,
        impuestosTotales,
        primaTotal,
        impuestosDetalle,
        urlPdf: this.props.datosProcesoCarritoAccP.procesoCarritoAccP.carUrlPdf,
      });
    }
  }

  async componentDidMount() {
    window.scroll(0, 0);

    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarritoUrl = queryParams.get("id");

    //se obtiene el id del carrito de la url o del stateLocal

    let idCarrito = "";

    if (
      idCarritoUrl !== undefined &&
      idCarritoUrl !== null &&
      idCarritoUrl !== ""
    ) {
      idCarrito = idCarritoUrl;
    } else {
      idCarrito = this.props.datosCarritoAccP.productoAccP.idCarrito;
    }

    if (idCarrito === undefined || idCarrito === null || idCarrito === "") {
      idCarrito = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .mongoCarrito;
    }

    this.setState({
      idCarrito,
    });

    await this.props.recuperarCarrito({
      empresa: "AIGMETROPOLITANA",
      idCarrito: idCarrito,
    });

    if (!this.props.datosRecuperarCarritoAccP.recuperarCarritoAccPhasError) {
      let datosUbicacion = this.props.datosRecuperarCarritoAccP
        .recuperarCarritoAccP.datosUbicacion;

      const {
        datosContratanteEmpresa,
        datosContratantePersona,
        nomEmpresa,
        nomPersona,
      } = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP;

      const dataPlan = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .carProductos[0];

      this.setState({
        ciudad: datosUbicacion.ciudad,
        provincia: datosUbicacion.provincia,
        direccion: datosUbicacion.direccion,
        idEmpresa: datosContratanteEmpresa.cliIdentificacion,
        idPersona: datosContratantePersona.cliIdentificacion,
        nomEmpresa: datosContratanteEmpresa.cliRazonSocial,
        nomPersona: datosContratantePersona.nombreCompleto,
        periocidad: dataPlan.periodicidad,
        periodoSeleccionado: dataPlan.periodicidad,
        msgFactuacion: dataPlan.mensajeResumen
          ? dataPlan.mensajeResumen
          : "La periodicidad de la facturacion es Anual.",
        actividadEmpresa: dataPlan.actividad.label
          ? dataPlan.actividad.label
          : "",
        datosPlan: dataPlan,
      });

      let dataCarrito = this.props.datosRecuperarCarritoAccP
        .recuperarCarritoAccP;
      let pasoCarrito = this.props.datosRecuperarCarritoAccP
        .recuperarCarritoAccP
        ? this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.pasoCarrito
        : "";
      console.log("dataCarrito", dataCarrito);
      console.log("PasoCarrito", pasoCarrito);
      this.setState({ rendervista:pasoCarrito!==ConstVista.vistaAgregarPersonal?"resumen":ConstVista.vistaAgregarPersonal});
      //if (pasoCarrito === ConstVista.vistaResumen) {
        await this.props.procesoCarrito({
          empresa: "AIGMETROPOLITANA",
          pasoCarrito: "resumen",
          //periocidad: this.state.periodoSeleccionado,
          periocidad: this.state.periocidad,
          idCarrito: idCarrito,
          codigoProductoActual: dataPlan.codigo,
        });

        if (!this.props.datosProcesoCarritoAccP.procesoCarritoAccPhasError) {
          const {
            PrimaNeta,
            impuestosTotales,
            primaTotal,
            impuestosDetalle,
          } = this.props.datosProcesoCarritoAccP.procesoCarritoAccP.datosCalculados;
          if (
            this.props.datosProcesoCarritoAccP &&
            this.props.datosProcesoCarritoAccP.procesoCarritoAccP &&
            this.props.datosProcesoCarritoAccP.procesoCarritoAccP.mensajeResumen
          ) {
            this.setState({
              msgFactuacion: this.props.datosProcesoCarritoAccP
                .procesoCarritoAccP.mensajeResumen,
            });
          }

          this.setState({
            PrimaNeta,
            impuestosTotales,
            primaTotal,
            impuestosDetalle,
            urlPdf: this.props.datosProcesoCarritoAccP.procesoCarritoAccP
              .carUrlPdf,
          });
        }
      }

      /*  this.setState({
          idCarrito:this.props.datosCarritoAPTravelGroup.carritoAPTravelGroup['mongoCarrito']
      })  */
    /*} else {
      console.log("other view");
    }*/
    await this.props.obtenerPlanes({
      empresa: "AIGMETROPOLITANA",
      cotizador: "accidentesPersonales"
    });
  }

  
  async onClickRegresar(e) {

    const dataPlan = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .carProductos[0];

     console.log('estadoARevisar', dataPlan)

   if(dataPlan.plan.name == 'Guardias'){
    this.props.history.replace({
      pathname: `/vigencia-cotizacion-accidente-personal`,
      search: "?id=" + this.state.idCarrito,
    });
   }else{
    this.props.history.replace({
      pathname: `/servicios-cotizacion-accidente-personal`,
      search: "?id=" + this.state.idCarrito,
    });
   }
   
  }

  async onDescargar(event) {
    this.setState({
      okDescarga: false,
      linkDescarga: "",
    });

    event.preventDefault();
    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "descargar",
      correo: "",
      idCarrito: this.state.idCarrito,
    };

    await this.props.descargarCotizacion(datosJson);

    if (!this.props.generarCotizacionPdfAP.generarCotizacionAPhasError) {
      this.setState({
        okDescarga: true,
        linkDescarga: this.props.generarCotizacionPdfAP.generarCotizacionAP.url,
      });
    }
    //let datosPago=this.props.datosCotizacion.datosDescarga;
    /*  if (!this.props.datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    } */
  }

  async onEnviar(event, correo) {
    event.preventDefault();

    this.setState({
      okEnvio: false,
      linkDescarga: "",
    });

    let datosJson = {
      // empresa: "AIGMETROPOLITANA",
      // plataforma: "WEB",
      accion: "enviar",
      correo: correo,
      idCarrito: this.state.idCarrito,
    };

    await this.props.enviarCotizacion(datosJson);

    if (
      this.props.datosEnviarCotizacionPdfAccP &&
      !this.props.datosEnviarCotizacionPdfAccP.enviarCotizacionAccPhasError
    ) {
      this.setState({
        okEnvio: true,
        linkDescarga: this.state.urlPdf,
      });
    }
  }
  addListPlan = (data, type) => {
    let { dataPersonalPlan, dataPersonalAdm } = this.state;
    if (type === ConstVista.listaPrincipal) {
      dataPersonalPlan.push(data);
    } else {
      dataPersonalAdm.push(data);
    }
  };
  onRemoveListPlan = (datatable, type) => {
    if (type === ConstVista.listaPrincipal) {
      let array = this.state.dataPersonalPlan.filter(
        (item) => item.id !== datatable.id
      );
 
      this.setState({ dataPersonalPlan: array });
    } else {
      let array = this.state.dataPersonalAdm.filter(
        (item) => item.id !== datatable.id
      );
 
      this.setState({ dataPersonalAdm: array });
    }
  };
  changeVista = (type) => {

    this.setState({ rendervista: type });
  };

  render() {
    const {
      idEmpresa,
      idPersona,
      nomEmpresa,
      nomPersona,
      ciudad,
      provincia,
      direccion,
      PrimaNeta,
      impuestosTotales,
      primaTotal,
      impuestosDetalle,
      periodoSeleccionado,
      msgFactuacion,
      actividadEmpresa,
    } = this.state;

    let seccion = "";

    const arrayPeriodos = [
      { id: "", name: "Seleccione una opción" },
      { id: "0", name: "Anual" },
      { id: "1", name: "Mensual" },
    ];

    let texto = "Cargando...";

    {
      this.props.generarCotizacionPdfAP.generarCotizacionCarritoAPIsLoading
        ? (texto = "Estamos generando tu cotización")
        : this.props.datosEnviarCotizacionPdfAccP
            .enviarCotizacionCarritoAPIsLoading
        ? (texto = "Estamos enviando tu cotización")
        : (texto = "Cargando...");
    }

    return (
      <LoadingScreen
        loading={
          this.props.datosRecuperarCarritoAccP.recuperarCarritoAccPIsLoading ||
          this.props.generarCotizacionPdfAP
            .generarCotizacionCarritoAPIsLoading ||
          this.props.datosEnviarCotizacionPdfAccP
            .enviarCotizacionCarritoAccPIsLoading ||
          this.props.datosProcesoCarritoAccP.procesoCarritoAccPIsLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={texto}
      >
        <Page
          title="Cotización Accidentes Personales"
          breadcrumbs={[
            { name: "Cotización Accidentes Personales", active: true },
          ]}
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step"> {` 1. Cotización `} </div>
                    <div className="step current"> {` 2. Resumen `} </div>
                    <div className="step"> {` 3. Confirmación `} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {this.state.rendervista === ConstVista.vistaResumen ? (
            //Render Resumen Cotización
            <Row>
              <Col
                lg={8}
                md={12}
                sm={12}
                xs={12}
                className="detalle-cotizacion-box"
              >
                <div>
                  <Card className="flex-row">
                    <CardBody>
                      <h4 style={{ fontWeight: "bold" }}>Resumen.</h4>

                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          <h4>RUC:</h4>
                        </Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          {idEmpresa}{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          <h4>Nombre de la empresa:</h4>
                        </Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          {nomEmpresa}{" "}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={11} md={11} sm={11} xs={12}>
                          <h4>Actividad de la empresa:</h4>
                        </Col>
                        {/* <Col lg={5} md={5} sm={5} xs={12}>                        
           </Col> */}
                      </Row>
                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col
                          lg={10}
                          md={10}
                          sm={10}
                          xs={12}
                          style={{ textAlign: "justify", fontSize: "13px" }}
                        >
                          {actividadEmpresa}{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          <h4>CI del solicitante:</h4>
                        </Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          {idPersona}{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          <h4>Nombre del solicitante:</h4>
                        </Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          {nomPersona}{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          <h4>Provincia:</h4>
                        </Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          {provincia.label}{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          <h4>Ciudad:</h4>
                        </Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          {ciudad.label}{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={1} md={1} sm={1} xs={0}></Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          <h4>Dirección:</h4>
                        </Col>
                        <Col lg={5} md={5} sm={5} xs={12}>
                          {direccion}{" "}
                        </Col>
                      </Row>

                      <hr style={{ borderTop: "1px solid" }}></hr>

                      <Row style={{ paddingTop: "30px" }}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <p style={{ textAlign: "center" }}>
                            {/* {" "} Por favor selecciona la periodicidad de facturación{" "} */}
                            {/* {msgFactuacion} */}
                          </p>
                          <Alert color="info">
                            <center>
                              <p>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: msgFactuacion,
                                  }}
                                />
                              </p>
                            </center>
                          </Alert>
                        </Col>

                        <Col
                          lg={4}
                          md={4}
                          sm={12}
                          xs={12}
                          style={{ display: "none" }}
                        >
                          <Select
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"perido"} // Optional.[String].Default: "". Input ID.
                            name={"periodo"} // Optional.[String].Default: "". Input name.
                            value={periodoSeleccionado} // Optional.[String].Default: "".
                            optionList={arrayPeriodos} // Required.[Array of Object(s)].Default: [].
                            onChange={(periodoSeleccionado, e) => {
                              this.setState({ periodoSeleccionado });
                              console.log("el periodo es", periodoSeleccionado);
                              //console.log(e);
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validationOption={{
                              name: "selectPeriodos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione un periodo",
                            }}
                          />
                        </Col>
                      </Row>

                      <br />

                      {this.props.datosProcesoCarritoAccP &&
                        this.props.datosProcesoCarritoAccP.procesoCarritoAccP &&
                        this.props.datosProcesoCarritoAccP.procesoCarritoAccP.calculosResumen &&
                        this.props.datosProcesoCarritoAccP.procesoCarritoAccP.calculosResumen.map(
                          (opcDetalle) => {
                           
                            var nuevoTitulo = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].plan.descripcion;

                            
                            let mostrarTitulo = false;
                            if (opcDetalle.planListado !== seccion) {
                              seccion = opcDetalle.planListado;
                              mostrarTitulo = true; 
                            }

                            if (opcDetalle.numeroPersonas !== "0" && opcDetalle.numeroPersonas !== 0) {
                              return (
                                <div key={seccion}>
                                  {mostrarTitulo && (
                                    <Row>
                                      <Col lg={1} md={1} sm={1} xs={0}></Col>
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        style={{ fontSize: "25px" }}
                                      >
                                        {nuevoTitulo}
                                      </Col>
                                    </Row>
                                  )}

                                  {opcDetalle.datosOpciones.map(
                                    (dato) =>
                                      dato.numeroPersonas !== 0 &&
                                      dato.numeroPersonas !== "0" && (
                                        <div key={dato.opcion}>
                                          <Row>
                                            <Col lg={1} md={1} sm={1} xs={0}></Col>
                                            <Col lg={5} md={5} sm={5} xs={12}>
                                              <h4 style={{ fontWeight: "bold" }}>
                                                Opción Seleccionada:
                                              </h4>
                                            </Col>
                                            <Col
                                              lg={5}
                                              md={5}
                                              sm={5}
                                              xs={12}
                                              style={{ color: "#c7027e", fontSize: "25px" }}
                                            >
                                              {dato.opcion}
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col lg={1} md={1} sm={1} xs={0}></Col>
                                            <Col lg={5} md={5} sm={5} xs={12}>
                                              <h4 style={{ fontWeight: "bold" }}>
                                                Número de personas:
                                              </h4>
                                            </Col>
                                            <Col
                                              lg={5}
                                              md={5}
                                              sm={5}
                                              xs={12}
                                              style={{ color: "#c7027e", fontSize: "25px" }}
                                            >
                                              {dato.numeroPersonas}
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col lg={1} md={1} sm={1} xs={0}></Col>
                                            <Col lg={5} md={5} sm={5} xs={12}>
                                              <h4 style={{ fontWeight: "bold" }}>
                                                Prima neta {dato.periodo.toLowerCase()} por persona:
                                              </h4>
                                            </Col>
                                            <Col
                                              lg={5}
                                              md={5}
                                              sm={5}
                                              xs={12}
                                              style={{ color: "#c7027e", fontSize: "25px" }}
                                            >
                                              $ {dato.primaNeta}
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col lg={1} md={1} sm={1} xs={0}></Col>
                                            <Col lg={5} md={5} sm={5} xs={12}>
                                              <h4 style={{ fontWeight: "bold" }}>
                                                Prima neta {dato.periodo.toLowerCase()} total:
                                              </h4>
                                            </Col>
                                            <Col
                                              lg={5}
                                              md={5}
                                              sm={5}
                                              xs={12}
                                              style={{ color: "#c7027e", fontSize: "25px" }}
                                            >
                                              $ {dato.totalPersona}
                                            </Col>
                                          </Row>

                                          <hr />
                                        </div>
                                      )
                                  )}
                                </div>
                              );
                            }
                          }
                        )}

        
                      <Row style={{ marginTop: "40px" }}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Button
                            className="btn btn-detail-gray button-align-rigth"
                            onClick={this.onClickRegresar}
                          >
                            <i
                              className="fa fa-pencil-square-o"
                              aria-hidden="true"
                            />{" "}
                            EDITAR
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Col>

              <Col lg={4} md={12} className="detalle-impuestos-box">
                <ValoresCotizacionAccPersonal
                  primaNeta={PrimaNeta}
                  primaTotal={primaTotal}
                  metodoDescargar={this.onDescargar.bind(this)}
                  metodoEnviar={this.onEnviar.bind(this)}
                  sumaImpuestos={impuestosTotales}
                  paso={"valores-cotizacion"}
                  impuestos={impuestosDetalle}
                  linkDescarga={this.state.urlPdf}
                  okEnvio={this.state.okEnvio}
                  changeVista={this.changeVista}
                  isAP={false}
                  idCarrito={this.state.idCarrito}
                  actualizado={false}
                />
              </Col>
            </Row>
          ) : (
            //Render Agregar Resumen
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
              <AgregarPersonas
           
                addPersonas={this.addListPlan}
                onRemovePersonas={this.onRemoveListPlan}
                listPlan={this.state.dataPersonalPlan}
                listPlanAdmin={this.state.dataPersonalAdm}
                planActual={this.state.datosPlan}
                planPrincipal={this.state.datosPlanPrincipal}
                planSecundario={this.state.datosPlanSecundario}
                changeVista={this.changeVista}
                primaNeta={PrimaNeta}
                idCarrito={this.state.idCarrito}
                primaTotal={primaTotal}
                metodoDescargar={this.onDescargar.bind(this)}
                metodoEnviar={this.onEnviar.bind(this)}
                sumaImpuestos={impuestosTotales}
                paso={"valores-cotizacion"}
                impuestos={impuestosDetalle}
                linkDescarga={this.state.urlPdf}
                okEnvio={this.state.okEnvio}
                planesCotizacionAccP={this.props.listaPlanesAccP.planesCotizacionAccP}
                recuperarCarrito={this.recuperarCarrito}
                
              /></Col>
            </Row>
          )}
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosCarritoAccP: state.datosCarritoAccP,
  datosProductoCarritoAPTravelGroup: state.datosProductoCarritoAPTravelGroup,
  generarCotizacionPdfAP: state.generarCotizacionPdfAP,
  datosEnviarCotizacionPdfAccP: state.datosEnviarCotizacionPdfAccP,
  datosRecuperarCarritoAccP: state.datosRecuperarCarritoAccP,
  datosProcesoCarritoAccP: state.datosProcesoCarritoAccP,
  listaPlanesAccP: state.listaPlanesAccP,

});

const ConstVista = {
  vistaResumen: "resumen",
  vistaAgregarPersonal: "ingresoDePersonas",
  listaPrincipal: "principal",
  listaSecundaria: "secundaria",
};
const mapDispatchToProps = (dispatch) => {
  return {
    descargarCotizacion: (datos) => dispatch(FetchDescargarCotizacion(datos)),
    enviarCotizacion: (datos) => dispatch(FetchEnviaCotizacionAccP(datos)),
    recuperarCarrito: (datos) => dispatch(fetchRecuperarCarritoAccP(datos)),
    obtenerPlanes: (datos) => dispatch(fetchObtenerPlanes(datos)),
    procesoCarrito: (datos) => dispatch(fetchProcesoCarritoAccP(datos)),
    updateprocesoCarrito: (datos) => dispatch(fetchUpdateProcesoCarritoAccP(datos))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListadoProductoAPersonal)
);
